import { nextTick } from 'vue'
import { sessionStore } from '@gto/gw-store'
import axios from 'axios'
import $scriptjs from 'scriptjs'

// TODO: replace with lib client
const baseURL = import.meta.env.VITE_API_BASE_URL || 'https://api.dev.gtowizard.com'

const initNolt = async (selector: string) => {
  if (!window.noltToken) {
    const { data } = await axios.get(`${baseURL}/v1/account/nolt-token/`, {
      headers: {
        Authorization: `Bearer ${sessionStore.getState().accessToken}`,
      },
    })
    window.noltToken = data?.token
  }

  if (!window.noltToken || typeof window.nolt !== 'function') {
    return
  }

  await nextTick().then(() => {
    window.nolt('init', {
      url: 'https://gto-wizard.nolt.io',
      selector,
    })
    window.nolt('identify', {
      jwt: window.noltToken,
    })
  })
  window.noltLoaded = true
}

export const loadNoltWidget = (selector = '.init_nolt_btn') => {
  if (window.noltLoaded) {
    return
  }
  if (typeof window.nolt === 'function') {
    initNolt(selector)
    return
  }
  $scriptjs('https://cdn.nolt.io/widgets.js', () => {
    initNolt(selector)
  })
}
